import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
export function BundleSection() {
  const transformations = [{
    before: 'Te despiertas con ansiedad',
    after: 'Te despiertas con algo sólido adentro'
  }, {
    before: 'Explotas antes de pensar',
    after: 'Respiras primero — respondes después'
  }, {
    before: 'Tu mente no para en la noche',
    after: 'Duermes de verdad'
  }, {
    before: 'Te sientes sola con todo',
    after: 'Tienes herramientas que son tuyas'
  }, {
    before: 'La culpa es constante',
    after: 'Empiezas a ser tu propia aliada'
  }, {
    before: 'El caos te paraliza',
    after: 'La calma te abre camino'
  }];
  return <section className="py-24 bg-cream" data-id="element-44">
      <div className="max-w-7xl mx-auto px-6 md:px-8" data-id="element-45">
        <FadeIn className="text-center mb-16" data-id="element-46">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-brown" data-id="element-47">
            Esto es lo que cambia en tu vida
          </h2>
          <p className="text-xl text-gold-dark font-heading italic" data-id="element-48">
            ANTES 🌪️ → DESPUÉS 🌿
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-49">
          <FadeIn direction="right" className="order-2 lg:order-1" data-id="element-50">
            <div className="space-y-4" data-id="element-51">
              {transformations.map((item, index) => <div key={index} className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 p-5 bg-warm-deep/30 rounded-2xl border border-warm-deep hover:bg-warm-deep/50 transition-colors" data-id="element-52">
                  <div className="flex-1" data-id="element-53">
                    <p className="text-brown-light/80 line-through decoration-brown-light/30" data-id="element-54">
                      {item.before}
                    </p>
                  </div>
                  <div className="hidden sm:flex text-gold flex-shrink-0" data-id="element-55">
                    <ArrowRight size={20} data-id="element-56" />
                  </div>
                  <div className="flex-1" data-id="element-57">
                    <p className="text-brown font-bold" data-id="element-58">{item.after}</p>
                  </div>
                </div>)}
            </div>

            
          </FadeIn>

          <FadeIn direction="left" className="order-1 lg:order-2 relative" data-id="element-59">
            <div className="absolute inset-0 bg-gradient-to-tr from-gold/10 to-sage/10 rounded-full blur-3xl -z-10" data-id="element-60" />
            <img src="https://cdn.magicpatterns.com/uploads/5CGgkmwMoWn4AChkESpcuT/mockup_.png" alt="Transformación De Caos a Calma" className="w-full h-auto object-contain drop-shadow-xl" data-id="element-61" />
          </FadeIn>
        </div>
      </div>
    </section>;
}